import Instantiation from "./views/Instantiation.vue";
import WorkspaceEditor from "../workspaces/views/WorkspaceEditor.vue";

const moduleRoutes = [
	{
		path: "/beta/instantiate/:domainId/:templateWorkspaceId/:betaCaseId/:presetId",
		name: "Instantiation",
		component: Instantiation,
	},
	{
		path: "/beta/instance/:domainId/:workspaceId/:betaCaseId/:presetId",
		name: "betaEditor",
		component: WorkspaceEditor,
	},
];

export default moduleRoutes;
